import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Document from "../PortalForms/Document";
import FormsLibrary from "../PortalForms/FormsLibrary";
import InternalReview from "../PortalForms/InternalReview";
import MessageWithApplicant from "../PortalForms/MessageWithApplicant";
import ScheduleMeeting from "../PortalForms/ScheduleMeeting";
import TemplateLibrary from "../PortalForms/TemplateLibrary";
import PhoneCallApplicant from "../PortalForms/PhoneCallApplicant";
import WordEditor from "../../app/components/Tools/WordEditor";
import { useDispatch, useSelector } from "react-redux";
import {
  getComponentUpdateStatus, getComponentUserStatus,
  loadComponentUserStatus, loadToolsCount, UpdateComponentsUserStatus
} from "../../app/store/tools";
import { getCurrentUser } from "../../app/store/auth";
import { getWfPhasesColor } from "../../services/appService";

const getToolIcon = (id) => {
  switch (id) {
    case 7: return "fa-clock-o";
    case 9: return "fa-comments-o";
    case 10: return "fa-phone";
    case 11: return "fa-calendar";
    case 49: return "fa-file-word-o";
    case 41:
    case 26: return "fa-pencil-square-o";
    case 18: return "fa-folder-open-o";
    case 24: return "fa-archive";
    case 25: return "fa-file-text-o";
    default: return "fa-wrench";
  }
};

const formatUSPhoneNumber = (phoneNo) => {
  if (!phoneNo) return "";
  const cleaned = ("" + phoneNo).replace(/\D/g, "");
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNo;
};

const ToolsPopup = (props) => {
  const {
    setViewBprmFormShowHide,
    toolObj: t,
    uploadType,
    candidateObj,
    app,
    item,
    handleToolShowHide,
    toolShowHide,
    onClose
  } = props;

  const currentTask = props.task || props.workItem || props.workflowTask;

  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const componentUpdateStatusSelector = useSelector(getComponentUpdateStatus);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const candidateName = candidateObj?.performerName || candidateObj?.name || item?.performername || item?.name || item?.label || item?.companyName || currentTask?.performerName || "";
  const email = candidateObj?.performeremail || candidateObj?.email || item?.performeremail || item?.email || "";
  const phone = candidateObj?.contactNo || item?.contactNo || candidateObj?.companyPhone || item?.companyPhone || "";

  const getToolDescription = (id) => {
    switch (id) {
      case 7: return "Manage reminders, trigger notifications, and configure follow-up schedules.";
      case 9: return "Send real-time updates, request modifications, or chat directly with the candidate.";
      case 10: return "Log calls, summarize discussions, and record candidate conversation details.";
      case 11: return "Schedule onboarding syncs, technical interviews, or partner meetings.";
      case 49: return "Create and edit customized text agreements, engagement letters, or offer templates.";
      case 41:
      case 26: return "Prepare and transmit digital onboarding forms for secure e-signature via Docusign.";
      case 18: return "Browse, complete, and download compliance, registration, and work authorization forms.";
      case 24: return "Access standard letter layouts, emails, or policy statement templates.";
      case 25: return "Review contract values, terms, and generate commercial purchase orders.";
      default: return "Access additional workspace features and process resources.";
    }
  };
  const toolDescription = t ? getToolDescription(t.id) : "";

  const handleUpdateComponent = (compItems) => {
    if (!t || !currentTask) return;
    const comp = componentUserStatusSelector.filter(x => x.compId === t.id);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: t.name,
      performerId: currentUser.id,
      compItems: compItems,
      ciid: currentTask.ciid,
      wiid: currentTask.wiid,
      iiid: currentTask.iiid,
      compId: t.id
    };
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  };

  useEffect(() => {
    if (componentUpdateStatusSelector && currentTask?.ciid > 0) {
      dispatch(loadToolsCount(currentTask.ciid));
      dispatch(loadComponentUserStatus(currentUser.id, currentTask.ciid));
    }
  }, [componentUpdateStatusSelector]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else if (handleToolShowHide) {
      handleToolShowHide(null);
    }
  };

  const phaseClass = currentTask?.wfPhase === "Application"
    ? "btn-wf2-default"
    : (getWfPhasesColor(currentTask?.wfPhase) || "btn-default");
  const themeClass = phaseClass.replace("btn-", "theme-");

  return t && (
    <Modal
      show={Boolean(toolShowHide)}
      onHide={handleClose}
      size="xl"
      dialogClassName={`rt-tools-modal rt-tool-${t.id} ${themeClass}`}
      centered
      scrollable
      backdrop="static"
      keyboard={false}
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of the sidebar (1050) and header (1060) */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .rt-tools-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .rt-tools-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .rt-tools-modal {
          --task-accent: #64748b;
          --task-soft: #f8fafc;
          max-width: 90% !important;
          width: 1200px !important;
        }
        .rt-tools-modal.modal-dialog-centered.modal-dialog-scrollable {
          height: auto !important;
        }
        .rt-tools-modal.theme-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
        .rt-tools-modal.theme-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
        .rt-tools-modal.theme-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
        .rt-tools-modal.theme-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
        .rt-tools-modal.theme-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
        .rt-tools-modal.theme-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
        .rt-tools-modal.theme-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
        .rt-tools-modal.theme-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
        .rt-tools-modal.theme-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
        .rt-tools-modal.theme-default,
        .rt-tools-modal.theme-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

        .rt-tools-modal .modal-content {
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          max-height: calc(100vh - 60px) !important;
          height: auto !important;
          display: flex !important;
          flex-direction: column !important;
        }
        .rt-tools-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }
        .rt-tools-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }
        .rt-tools-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 14px !important;
          width: 100% !important;
        }
        .rt-tools-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }
        .rt-tools-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-tools-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }
        .rt-tools-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-tools-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .rt-tools-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-tools-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--task-soft) !important;
          color: var(--task-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }
        .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 12px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          color: #64748b !important;
        }
        .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
        }
        .rt-meta-chip i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }
        .rt-meta-divider {
          width: 1px !important;
          height: 16px !important;
          background: #cbd5e1 !important;
          margin: 0 4px !important;
        }
        .rt-meta-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
        }
        .rt-meta-desc i {
          color: var(--task-accent) !important;
        }

        .rt-tools-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 180px) !important;
          overflow-y: auto !important;
        }
        .rt-tools-modal.rt-tool-9 .modal-body {
          max-height: calc(100vh - 210px) !important;
          overflow: hidden !important;
        }
        /* Premium Header Close Button */
        .rt-tools-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .rt-tools-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-tools-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .rt-tools-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .rt-tools-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        /* Premium Modal Footer Close Button */
        .rt-tools-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }
        .rt-tools-modal .wf-modal-footer-close-btn:hover i {
          color: #ef4444 !important;
        }

        /* Custom scrollbar for modal body */
        .rt-tools-modal .modal-body::-webkit-scrollbar {
          width: 6px !important;
          height: 6px !important;
        }
        .rt-tools-modal .modal-body::-webkit-scrollbar-track {
          background: transparent !important;
        }
        .rt-tools-modal .modal-body::-webkit-scrollbar-thumb {
          background: #cbd5e1 !important;
          border-radius: 4px !important;
        }
        .rt-tools-modal .modal-body::-webkit-scrollbar-thumb:hover {
          background: #94a3b8 !important;
        }

        /* General form overrides inside the tool modal for modern rich UI */
        .rt-tools-modal .modal-body label,
        .rt-tools-modal .modal-body .control-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-bottom: 6px !important;
        }
        .rt-tools-modal .modal-body input[type="text"],
        .rt-tools-modal .modal-body input[type="email"],
        .rt-tools-modal .modal-body input[type="date"],
        .rt-tools-modal .modal-body input[type="time"],
        .rt-tools-modal .modal-body select,
        .rt-tools-modal .modal-body textarea,
        .rt-tools-modal .modal-body .form-control {
          font-size: 12px !important;
          color: #0f172a !important;
          background-color: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          padding: 8px 12px !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
          outline: none !important;
        }
        .rt-tools-modal .modal-body input:focus,
        .rt-tools-modal .modal-body select:focus,
        .rt-tools-modal .modal-body textarea:focus,
        .rt-tools-modal .modal-body .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1), 0 1px 2px rgba(0,0,0,0.05) !important;
          outline: none !important;
        }
        
        /* Modernized tables inside tools */
        .rt-tools-modal .modal-body table.table,
        .rt-tools-modal .modal-body .table {
          width: 100% !important;
          margin-bottom: 1rem !important;
          color: #334155 !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          overflow: hidden !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02) !important;
        }
        .rt-tools-modal .modal-body table.table th,
        .rt-tools-modal .modal-body .table th {
          background-color: #f8fafc !important;
          color: #475569 !important;
          font-weight: 700 !important;
          font-size: 11px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.03em !important;
          padding: 10px 14px !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-top: none !important;
        }
        .rt-tools-modal .modal-body table.table td,
        .rt-tools-modal .modal-body .table td {
          padding: 10px 14px !important;
          font-size: 12px !important;
          vertical-align: middle !important;
          border-bottom: 1px solid #f1f5f9 !important;
          border-top: none !important;
          background: #ffffff !important;
        }
        .rt-tools-modal .modal-body table.table tr:last-child td,
        .rt-tools-modal .modal-body .table tr:last-child td {
          border-bottom: none !important;
        }
        .rt-tools-modal .modal-body table.table tbody tr:hover td,
        .rt-tools-modal .modal-body .table tbody tr:hover td {
          background-color: #f8fafc !important;
        }

        /* Upgrade internal buttons inside forms */
        .rt-tools-modal .modal-body .btn,
        .rt-tools-modal .modal-body button.btn-primary,
        .rt-tools-modal .modal-body button.btn-default,
        .rt-tools-modal .modal-body button.btn-success {
          padding: 7px 12px !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          border-radius: 6px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
        }
        .rt-tools-modal .modal-body .btn-primary {
          background-color: #2563eb !important;
          border-color: #2563eb !important;
          color: #ffffff !important;
        }
        .rt-tools-modal .modal-body .btn-primary:hover,
        .rt-tools-modal .modal-body .btn-primary:focus {
          opacity: 0.9 !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
        }
        .rt-tools-modal .modal-body .btn-success {
          background-color: #10b981 !important;
          border-color: #10b981 !important;
          color: #ffffff !important;
        }
        .rt-tools-modal .modal-body .btn-success:hover {
          background-color: #059669 !important;
          border-color: #059669 !important;
        }
        .rt-tools-modal .modal-body .btn-default {
          background-color: #f1f5f9 !important;
          border-color: #cbd5e1 !important;
          color: #475569 !important;
        }
        .rt-tools-modal .modal-body .btn-default:hover {
          background-color: #e2e8f0 !important;
          color: #334155 !important;
        }

        /* Card and section layout upgrades */
        .rt-tools-modal .modal-body .card,
        .rt-tools-modal .modal-body .panel {
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02) !important;
          overflow: hidden !important;
          margin-bottom: 16px !important;
          background: #ffffff !important;
        }
        .rt-tools-modal .modal-body .card-header,
        .rt-tools-modal .modal-body .panel-heading {
          background: #f8fafc !important;
          border-bottom: 1px solid #e2e8f0 !important;
          padding: 10px 16px !important;
          font-weight: 700 !important;
          font-size: 12px !important;
          color: #334155 !important;
        }
        .rt-tools-modal .modal-body .card-body,
        .rt-tools-modal .modal-body .panel-body {
          padding: 16px !important;
        }
      `}</style>
      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className={`rt-header-icon fa ${getToolIcon(t.id)}`} aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>{t.name}</span>
                    {currentTask?.wfPhase && (
                      <span className="rt-modal-title-badge">
                        {currentTask.wfPhase}
                      </span>
                    )}
                  </span>
                </h2>
                {(candidateName || email || phone || toolDescription) && (
                  <div className="rt-modal-meta-row">
                    {candidateName && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" /> {candidateName}
                      </span>
                    )}
                    {email && (
                      <span className="rt-meta-chip" title={email}>
                        <i className="fa fa-envelope" aria-hidden="true" /> {email}
                      </span>
                    )}
                    {phone && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-phone" aria-hidden="true" /> {formatUSPhoneNumber(phone)}
                      </span>
                    )}
                    {(candidateName || email || phone) && toolDescription && (
                      <span className="rt-meta-divider" />
                    )}
                    {toolDescription && (
                      <span className="rt-meta-desc">
                        <i className="fa fa-info-circle" aria-hidden="true" /> {toolDescription}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={handleClose}
              title="Close Tool"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {t.id === 9 && <MessageWithApplicant workflowTask={currentTask} handleUpdateComponent={handleUpdateComponent} />}
        {t.id === 10 && <PhoneCallApplicant workflowTask={currentTask} handleUpdateComponent={handleUpdateComponent} />}
        {t.id === 11 && <ScheduleMeeting workflowTask={currentTask} partitem={item} handleUpdateComponent={handleUpdateComponent} />}
        {t.id === 49 && <WordEditor workflowTask={currentTask} handleUpdateComponent={handleUpdateComponent} />}
        {t.id === 18 && (
          <FormsLibrary
            workflowTask={currentTask}
            candidateObj={candidateObj}
            uploadType={uploadType}
            setViewBprmFormShowHide={setViewBprmFormShowHide}
            handleUpdateComponent={handleUpdateComponent}
          />
        )}
        {t.id === 24 && <TemplateLibrary workflowTask={currentTask}
          setViewBprmFormShowHide={setViewBprmFormShowHide}
          handleUpdateComponent={handleUpdateComponent}
        />}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true" />
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ToolsPopup;
